module.exports = __webpack_public_path__ + "f0f4adec4e65d494b80f71621a1cf8a0.MP3";